// import ExpandLessIcon from "@mui/icons-material/ExpandLess";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Menu, MenuItem } from "@mui/material";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import Flex from "../../../../../components/Flex";
// import Text from "../../../../../components/Text";
import { useState } from "react";
import Text from "../../../../../components/Text";
import StyledButtonV2 from "../../../../../components/app/StyledButtonV2";
import { getExportIcon } from "../../../../../components/svg-icons/material-icons";
import { ExportPatientExportTypeEnum } from "../../../../../services";

type Export_TYPE = {
  label: string;
  src: string;
  value: ExportPatientExportTypeEnum;
}[];

const EXPORT_ITEM_LIST: Export_TYPE = [
  { label: "Export CSV", src: "/patient/export csv.svg", value: "CSV" },
  { label: "Export XLS", src: "/patient/export xls.svg", value: "XLS" },
  // { label: "Export CCDA", src: "/patient/export ccda.svg", value: "CCDA" },
  // { label: "Print List", src: "/patient/print list.svg", value: "" as any },
];

interface PatientExportProps {
  onClick: (v: ExportPatientExportTypeEnum) => void;
  disabled: boolean;
}

const PatientExport = ({ onClick, disabled }: PatientExportProps) => {
  const [curHoverEle, setCurHoverEle] = useState<string>();
  return (
    <PopupState variant="popover" popupId="create-navbar-button-menu">
      {(menuList) => (
        <>
          {/* <Button
            variant="outlined"
            {...bindTrigger(menuList)}
            disabled={disabled}
            sx={{
              height:"40px"
            }}
          >
            <Flex alignItems={"center"}>
              <Text c={disabled ? "gray" : "#21262B"}>Export List</Text>
              {bindMenu(menuList).open ? (
                <ExpandLessIcon />
              ) : (
                <ExpandMoreIcon />
              )}
            </Flex>
          </Button> */}
          <StyledButtonV2
            label="Export List"
            variant="outlined"
            {...bindTrigger(menuList)}
            disabled={disabled}
            sIcon={getExportIcon(disabled)}
          />

          <Menu {...bindMenu(menuList)}>
            <Flex flexWrap={"wrap"} width={"14.5rem"} p={1} gap={1}>
              {EXPORT_ITEM_LIST?.map((it) => (
                <MenuItem
                  onMouseEnter={() => setCurHoverEle(it.label)}
                  sx={{
                    width: "6.5rem",
                    padding: 0.5,
                  }}
                  onClick={() => {
                    menuList.close();
                    onClick(it.value);
                  }}
                >
                  <Box
                    width={"100%"}
                    bgcolor={curHoverEle === it.label ? "#EFF6FF" : "#FAFAFA"}
                  >
                    <Flex flexDirection={"column"}>
                      <img
                        style={{ width: "3rem", height: "3rem" }}
                        src={it.src}
                        alt={it.label + " Image"}
                      />
                      <Text>{it.label}</Text>
                    </Flex>
                  </Box>
                </MenuItem>
              ))}
            </Flex>
          </Menu>
        </>
      )}
    </PopupState>
  );
};

export default PatientExport;
